
import { defineComponent, PropType } from "vue";

import common from "../styles/common.module.less";

// 回调以 prop 形式传入（不新增依赖、不依赖组件事件类型推断）
export default defineComponent({
  name: "XiyouFilterTabs",
  props: {
    items: {
      type: Array as PropType<Array<{ label: string; value: string }>>,
      required: true,
    },
    modelValue: { type: String, default: "" },
    onChange: {
      type: Function as PropType<(value: string) => void>,
      default: undefined,
    },
  },
  setup(props) {
    return () => (
      <div class={common.tabs}>
        {props.items.map((item) => (
          <button
            key={item.value || "all"}
            type="button"
            class={[
              common.tab,
              item.value === props.modelValue ? common.tabActive : null,
            ]}
            onClick={() => {
              if (props.onChange && item.value !== props.modelValue) {
                props.onChange(item.value);
              }
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    );
  },
});
